<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 2 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center mt-4">
    <div class="col-md-10">
      <div class="card shadow-sm">
        <!-- <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center"> -->
        <div class="card-header card-header-icon">
          <div class="card-icon">
            <i class="material-icons">receipt</i>
          </div>
          <h4 class="card-title mb-0">
            {{ id ? "EDIT" : "NEW" }} SOCIAL REGISTRY ASSET
          </h4>
          <!-- <a
            routerLink="/marketing/social/registry"
            class="btn btn-sm btn-outline-light"
          >
            <i class="fas fa-arrow-left me-1"></i> BACK
          </a> -->
        </div>
        <div class="card-body">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="row g-3">
              <!-- Basic Asset Info -->
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small">Asset ID *</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="social_asset_id"
                    [class.is-invalid]="isFieldInvalid('social_asset_id')"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small">Internal Title</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="title_internal"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block">Platform *</label>
                  <select
                    class="form-select form-select-sm"
                    formControlName="platform"
                  >
                    <option *ngFor="let opt of platformOptions" [value]="opt">
                      {{ opt | uppercase }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Channel and Type -->
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block">Channel Target</label>
                  <select
                    class="form-select form-select-sm"
                    formControlName="channel_target"
                  >
                    <option *ngFor="let opt of channelOptions" [value]="opt">
                      {{ opt | uppercase }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block">Asset Type</label>
                  <select
                    class="form-select form-select-sm"
                    formControlName="asset_type"
                  >
                    <option *ngFor="let opt of assetTypeOptions" [value]="opt">
                      {{ opt | uppercase }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block">Status *</label>
                  <select
                    class="form-select form-select-sm"
                    formControlName="status"
                  >
                    <option *ngFor="let opt of statusOptions" [value]="opt">
                      {{ opt | uppercase }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Scope -->
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block">Vertical</label>
                  <select
                    class="form-select form-select-sm"
                    formControlName="vertical"
                  >
                    <option value="">N/A</option>
                    <option *ngFor="let opt of verticalOptions" [value]="opt">
                      {{ opt | uppercase }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block">Geo Scope Type</label>
                  <select
                    class="form-select form-select-sm"
                    formControlName="geo_scope_type"
                  >
                    <option value="">N/A</option>
                    <option
                      *ngFor="let opt of geoScopeTypeOptions"
                      [value]="opt"
                    >
                      {{ opt | uppercase }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Content and URLs -->
              <div class="col-12">
                <div class="form-group">
                  <label class="form-label fw-bold small">Caption</label>
                  <textarea
                    class="form-control form-control-sm"
                    formControlName="caption"
                    rows="3"
                  ></textarea>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label fw-bold small">Creative URL</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="creative_url"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label fw-bold small">Published URL</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="published_url"
                  />
                </div>
              </div>

              <!-- Scheduling and Tools -->
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block">Publish Tool</label>
                  <select
                    class="form-select form-select-sm"
                    formControlName="publish_tool"
                  >
                    <option
                      *ngFor="let opt of publishToolOptions"
                      [value]="opt"
                    >
                      {{ opt | uppercase }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small">Scheduled At</label>
                  <input
                    type="date"
                    class="form-control form-control-sm"
                    formControlName="scheduled_at"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small">Published At</label>
                  <input
                    type="date"
                    class="form-control form-control-sm"
                    formControlName="published_at"
                  />
                </div>
              </div>

              <div class="col-12 d-flex justify-content-end mt-4">
                <button
                  type="submit"
                  class="btn btn-dark btn-sm px-4 shadow-sm btn-new"
                  [disabled]="form.invalid"
                >
                  <i class="fas fa-save me-1"></i> SAVE ASSET
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
